import React, { createContext, useContext } from 'react'
import type { PropsWithChildren } from 'react'
import type { Row, Cell } from '@tanstack/react-table'

type DataTableRowContext<T extends object> = {
  row: Row<T>
  expandCell: Cell<T, unknown> | false
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const DataTableContext = createContext<DataTableRowContext<any> | null>(null)

type DataTableRowProviderProps<T extends object> = PropsWithChildren<{
  row: Row<T>
  expandCell: Cell<T, unknown> | false
}>
export function DataTableRowProvider<T extends object>({
  row,
  expandCell,
  children,
}: DataTableRowProviderProps<T>) {
  return (
    <DataTableContext.Provider value={{ row, expandCell }}>
      {children}
    </DataTableContext.Provider>
  )
}

export function useDataTableRowContext<T extends object>() {
  const context = useContext(
    DataTableContext as unknown as React.Context<DataTableRowContext<T>>
  )

  if (!context) {
    throw new Error(
      'useDataTableRowContext must be used within a DataTableRowProvider'
    )
  }

  return context
}
